import { useState } from 'react';

// Third-party
import IconButton from '@mui/material/IconButton';

// Components
import { ClockNavigation } from './components/ClockNavigation';

// Hooks
import { useClockStateAPI } from '../../hooks/api/useClock';

// Assets
import clock from '../../assets/clock.png';
import { useGetSheetsAPI } from '../../hooks/api/useSheets';
import { useAppSelector } from '../../hooks/useAppStore';
import { getSheets } from '../../store/sheets/selectors';

const Clock = () => {
  const {
    refetch: referchState,
  } = useClockStateAPI();
  const { refetch: refetchSheets } = useGetSheetsAPI();

  const sheets = useAppSelector(getSheets);

  const [isOpenNav, setIsOpenNav] = useState<boolean>(false);
  const handleOpen = async () => {
    if (!sheets.length) {
      await refetchSheets();
    }
    await referchState();
    setIsOpenNav(true);
  };

  const handleClose = () => {
    setIsOpenNav(false);
  };

  return (
    <>
      <IconButton
        disableRipple
        onClick={handleOpen}
        sx={{
          p: 0,
        }}
      >
        <img width={30} src={clock} alt="clock" />
      </IconButton>
      <ClockNavigation handleClose={handleClose} isOpenNav={isOpenNav} />
    </>
  );
};

export {
  Clock,
};
